export class Segments {

  constructor() {
    this.segments = [];
  }

  addSegment(segment) {
    this.segments.push(segment);
  }

  deleteSegment(index) {
    this.segments.splice(index, 1);
  }

  updateSegment(index, segment) {
    this.segments[index] = segment;
  }

  static fromBackEnd(source) {
    const result = new Segments();
    source.segments.forEach(
      sourceSegment => result.addSegment(Segment.fromBackEnd(sourceSegment))
    );
    return result;
  }
}


export class Segment {

  constructor(id, title) {
    this.title = title;
    this.isActive = true;
    this.logicOperator = 'AND';
    this.conditions = [];
    this.id = id;
  }

  addCondition(condition) {
    this.conditions.push(condition);
  }

  deleteCondition(index) {
    this.condition.splice(index, 1);
  }

  static fromBackEnd(source) {
    const result = new Segment(source.id, source.title);
    result.isActive = source.isActive;
    result.logicOperator = source.logicOperator;
    source.conditions.forEach(
      sourceCondition => result.addCondition(SegmentCondition.fromBackEnd(sourceCondition))
    );
    result.id = source.id;
    return result;
  }
}


export class SegmentCondition {

  constructor() {
    this.typeCode = null;
    this.parameters = null;
  }

  setTypeCode(typeCode) {
    this.typeCode = typeCode;
    this.parameters = SegmentConditionType.forCode(typeCode).defaultParamsFn();
  }

  isTypeVip() {
    return this.typeCode === typeCodes.vip;
  }
  isTypeLastMessageLanguage() {
    return this.typeCode === typeCodes.lastMessageLanguage;
  }
  isTypeSatisfactionBoxSelector() {
    return this.typeCode === typeCodes.satisfactionBoxSelector;
  }
  isTypeButtonClickSelector() {
    return this.typeCode === typeCodes.buttonClickSelector;
  }
  isTypeOptins() {
    return this.typeCode === typeCodes.optins;
  }
  isTypeConditionOnCustomField() {
    return this.typeCode === typeCodes.conditionOnCustomField;
  }


  static fromBackEnd(source) {
    const result = new SegmentCondition();
    result.typeCode = source.typeCode;
    result.parameters = angular.copy(source.parameters);
    return result;
  }
}


export class SegmentConditionType {

  constructor(code, defaultParamsFn) {
    this.code = code;
    this.defaultParamsFn = defaultParamsFn;
  }

  static codes() {
    return segmentConditionTypes.map(t => t.code);
  }

  static values() {
    return segmentConditionTypes;
  }

  static forCode(code) {
    return segmentConditionTypes.filter(t => t.code === code)[0];
  }
}

const typeCodes = {
  vip: 'vip',
  lastMessageLanguage: 'last-message-language',
  satisfactionBoxSelector: 'satisfaction-box-selector',
  buttonClickSelector: 'button-click-selector',
  optins: 'optins',
  conditionOnCustomField: 'custom-field'
}

const segmentConditionTypes = [
  new SegmentConditionType(typeCodes.vip, () => ({})),
  new SegmentConditionType(typeCodes.lastMessageLanguage, () => ({ 'language': null })),
  new SegmentConditionType(typeCodes.satisfactionBoxSelector, () => ({ 'surveyScenario': null, 'box': null, 'metric': null, 'inequalityCond': null, 'threshold': null })),
  new SegmentConditionType(typeCodes.buttonClickSelector, () => ({ 'scenario': null, 'box': null, 'button': null })),
  new SegmentConditionType(typeCodes.optins, () => ({ 'optins': [] })),
  new SegmentConditionType(typeCodes.conditionOnCustomField, () => ({ 'customField': null }))
];

